module.exports = __webpack_public_path__ + "static/media/courses-icon.d842c563.svg";